import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import 'hammerjs';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { AppNgrxModule } from '@xbaht/common/modules/app-ngrx.module';

import { LoggingFetchProvider } from '@xbaht/common/fetches/interceptors/logging-fetch.service';
import { EventFetchProvider } from '@xbaht/common/fetches/interceptors/event-fetch.service';
import { AuthenticationStore } from '@xbaht/common/stored/components/authentication.store';

import { CoreModule } from '@xbaht/ui/core/core.module';
import { CoreCommonModule } from '@xbaht/ui/core/common.module';
import { CoreSidebarsModule } from '@xbaht/ui/core/components/core-sidebars/core-sidebars.module';
import { CoreThemeCustomizersModule } from '@xbaht/ui/core/components/theme-customizers/theme-customizers.module';

import { LayoutsModule } from './views/layouts/layouts.module';

import { coreConfig } from './configs/app.config';
import { routes } from './configs/route.config';

import { InitializeProvider } from './initialize';

import { AppComponent } from './app.component';

import { environment } from 'environments/environment';
import { IMAGE_CONFIG } from '@angular/common';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
    TranslateModule.forRoot(),

    NgbModule,
    ToastrModule.forRoot({
      preventDuplicates: false,
    }),

    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarsModule,
    CoreThemeCustomizersModule,

    LayoutsModule,

    AppNgrxModule,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    InitializeProvider,
    !environment.production ? LoggingFetchProvider : [],
    EventFetchProvider,
    AuthenticationStore,
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true, 
        disableImageLazyLoadWarning: true,
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
